import * as React from 'react';

export default (props) => {
  let strokeColor;

  if (props.color) {
    strokeColor = props.color;
  } else {
    switch (props.state) {
      case 'hover':
        strokeColor = '#0A132B';
        break;
      case 'static':
        strokeColor = '#6C7280';
        break;
      case 'active':
        strokeColor = '#0067F4';
        break;
      default:
        strokeColor = '#B5BFD2';
    }
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      fill="none"
    >
      <path
        fill={strokeColor}
        fillRule="evenodd"
        d="M4.5 19a1 1 0 0 0 1 1h14a1 1 0 1 0 0-2h-13V5a1 1 0 1 0-2 0v14ZM20.078 6.184a1 1 0 0 1 .238 1.394l-4.783 6.75a1 1 0 0 1-1.577.07l-1.964-2.31-2.633 4.423a1 1 0 1 1-1.718-1.022l3.348-5.625a1 1 0 0 1 1.62-.137l2.037 2.395 4.038-5.7a1 1 0 0 1 1.394-.238Z"
        clipRule="evenodd"
      />
    </svg>
  );
};
